import { CancellableResult } from '../../../common/result';
import { TermsStepValue } from '../../../services/validation';
import AcceptTermsTask from '../background/AcceptTermsTask';
import StepWorker, { StepWorkerResult } from './StepWorker';

export default class AcceptTermsStep implements StepWorker {
  public requiresInit = false;

  private terms: TermsStepValue;

  constructor(terms: TermsStepValue) {
    this.terms = terms;
  }

  public async processStep(validationId: string): Promise<StepWorkerResult> {
    return {
      result: CancellableResult.noValueSuccess(),
      backgroundTask: new AcceptTermsTask(validationId, this.terms),
    };
  }
}
